// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1-TdE","boxTitle":"Qualiphy_boxTitle__UU6qg","box":"Qualiphy_box__2pgm4","toggleWrap":"Qualiphy_toggleWrap__1sFl6"};